import React from "react";

function CheckBoxInput(props) {
  const { field = "", input, setInput, disabled = false, s = 1.3 } = props;

  // Validate input structure
  if (!input || typeof input !== "object") {
    console.error("CheckBoxInput: input must be an object");
    return null;
  }

  if (!field || typeof field !== "string") {
    console.error("CheckBoxInput: field must be a string");
    return null;
  }

  // Safely get the field data
  const fieldData = input[field] || {};
  const checked = typeof fieldData.value === "boolean" ? fieldData.value : false;
  const isDisabled = typeof fieldData.disabled === "boolean" 
    ? fieldData.disabled 
    : disabled;

  function handleChange(e) {
    try {
      if (!setInput || typeof setInput !== "function") {
        console.error("CheckBoxInput: setInput must be a function");
        return;
      }

      setInput(prev => ({
        ...prev,
        [field]: {
          ...prev[field],
          value: e.target.checked
        }
      }));
    } catch (e) {
      console.error("CheckBoxInput error:", e.message);
    }
  }

  return (
    <div className="flex gap-x-2 items-center">
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={isDisabled}
        style={{
          height: `${s}em`,
          width: `${s}em`,
          cursor: isDisabled ? "not-allowed" : "pointer"
        }}
        className="rounded border-gray-300 text-primary focus:ring-primary"
      />
      {fieldData.label && (
        <span className="text-lg font-semibold text-gray-600">
          {fieldData.label}
        </span>
      )}
    </div>
  );
}

export default CheckBoxInput;